<template>
  <v-slide-y-transition>
    <div
      v-if="visible"
      class="position-fixed bottom-0 left-0 right-0"
      style="z-index: 3000"
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
    >
      <div class="mx-auto px-3 pb-3" style="max-width: 1170px">
        <v-sheet
          elevation="12"
          class="rounded-lg px-5 py-4 position-relative"
          color="surface"
          border
        >
          <div class="d-flex flex-column flex-md-row align-center">
            <div class="d-flex align-center ga-3 flex-grow-1">
              <v-icon icon="mdi-cookie" class="mx-auto" size="33" />
              <div class="text-body-2 text-medium-emphasis mx-auto">
                Usamos cookies para melhorar sua experiência de navegação. Ao
                aceitar, você concorda com nossa
                <RouterLink
                  class="text-secondary"
                  to="/legal/politica-de-privacidade"
                >
                  Política de Privacidade
                </RouterLink>
              </div>
            </div>

            <div
              class="d-flex ga-2 w-100 w-md-auto justify-center justify-md-end actions-cookie mt-md-0 align-center"
            >
              <v-btn variant="text" color="secondary" @click="onReject"
                >Rejeitar</v-btn
              >
              <v-btn color="primary" class="ml-1" @click="onAccept"
                >Aceitar</v-btn
              >
            </div>
          </div>
        </v-sheet>
      </div>
    </div>
  </v-slide-y-transition>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { RouterLink } from "vue-router";

import {
  hasCookieConsent,
  setCookieConsentAccepted,
  flushReferralQueueAfterLogin,
} from "@/utils/referralsTracker";

// grava "denied" (o referralsTracker só habilita tracking com "accepted")
function setCookieConsentDenied() {
  const secure = window.location.protocol === "https:";
  document.cookie = `mm_consent=denied; Max-Age=${
    60 * 60 * 24 * 180
  }; Path=/; SameSite=Lax${secure ? "; Secure" : ""}`;
}

const visible = ref(false);

onMounted(() => {
  const hasConsent = hasCookieConsent();
  const all = decodeURIComponent(document.cookie || "");
  const denied = /(?:^|;\s*)mm_consent=denied(?:;|$)/.test(all);
  visible.value = !(hasConsent || denied);
});

async function onAccept() {
  setCookieConsentAccepted();
  visible.value = false;
  try {
    if (this.$store?.state?.user?.id) {
      await flushReferralQueueAfterLogin();
    }
  } catch (e) {
    console.warn("Error flushReferralQueueAfterLogin: ", e);
  }
}

function onReject() {
  setCookieConsentDenied();
  visible.value = false;
}
</script>

<style scoped>
@media (max-width: 914px) {
  .actions-cookie {
    margin-top: 20px;
  }
}
</style>
